import { Chip } from "@mui/material";

type Status = "running" | "active" | "paused" | "error";

interface Props {
  status: Status;
  label: string;
}

const palette: Record<Status, { color: "default" | "primary" | "error"; variant?: "outlined" | "filled" }> = {
  running: { color: "primary" },
  active: { color: "primary", variant: "outlined" },
  paused: { color: "default", variant: "outlined" },
  error: { color: "error" }
};

export function StatusChip({ status, label }: Props) {
  const { color, variant } = palette[status];
  return <Chip color={color} variant={variant} label={label} />;
}
